import * as L from "leaflet";
import { Station } from "../../domain/types";
import { animateSpeedometerOutside, circleIcon, getStationStatus } from "./circleIcon";
import { createPopup } from "./popup";
import { getStationById } from "../../domain/storage/stationsStore";
import { getStatusManager, initStatusManager } from "../state/statusLayers";
import { getLastUpdatedSampleTimestamp } from "../data/latestData";
import { openSidebar, openSidebarPeek } from "../../domain/visuals/sidebar";
import { setQueryValue } from "../../domain/utils/urlUtils";
import { markDirty, refreshMarker } from "./refresh";
import { getMap } from "../initMap";

export const stationToMarker = new Map<string, L.Marker>();
export const markerToStation = new Map<L.Marker, string>();

export function addOrUpdateMarker(s: Station | undefined, map: L.Map, cluster: L.MarkerClusterGroup): L.Marker<any> | undefined {
	if (s == undefined || !s.Latitude || !s.Longitude) return;

	let m = stationToMarker.get(s.Id);
	if (!m) {
		m = L.marker([s.Latitude, s.Longitude], { icon: circleIcon(s), riseOnHover: true, riseOffset: 1000, title: s.Name, pane: "markerPane" });

		m.on("click", () => {
			document.querySelectorAll(".leaflet-marker-icon.selected")
				.forEach(el => el.classList.remove("selected"));

			m?.getElement()?.classList.add("selected");
			m?.getElement()?.classList.toggle("badges-open");
			m?.closeTooltip();
			openSidebar(s);
			//setQueryValue({ station: s.Id });
		});
		m.on("popupopen", () => {
			if (m) {
				const station = getStationById(markerToStation.get(m));
				if (station !== undefined) {
					console.log("Clicked station: ", station);
				}
				m.closeTooltip();
			}
		});
		m.on("tooltipopen", () => { if (m?.isPopupOpen()) m.closeTooltip(); });

		stationToMarker.set(s.Id, m);
		markerToStation.set(m, s.Id);

		const status = getStationStatus(getLastUpdatedSampleTimestamp(s).getTime());
		const statusMgr = getStatusManager();
		statusMgr.add(s.Id, m, status);
		refreshMarker(s, map);
	} else {
		markDirty(s.Id);
	}

	//refreshMarker(s, map);
	return m;
}
export function getMarkers(map: L.Map, cluster: L.MarkerClusterGroup | null, visibleOnly = true): L.Marker[] {
	if (!cluster) { return []; }
	const bounds = map.getBounds();
	const all = cluster.getLayers() as L.Marker[];
	const visible: L.Marker[] = [];
	if (!visibleOnly) {
		return all;
	}
	for (const m of all) {
		if (!bounds.contains(m.getLatLng())) {
			continue;
		}
		if (!cluster.getVisibleParent(m)) {
			continue;
		}
		visible.push(m);
	}
	return visible;
}